// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"42b1089b","633":"47c87387"}[chunkId] + ".chunk.js";
};